import { QuestionData } from 'store/store';

type AttemptCount = Pick<QuestionData, 'attemptCount'>;

const getAttempt = (maxAttempts, results): number => {
  if (window.dev && window.dev()) {
    return 1;
  }

  //

  const resultsKeys = Object.keys(results);

  let attemptCounts = resultsKeys.map(entry => {
    return results[entry].attemptCount;
  });

  const highestAttemptCount = Math.max(...attemptCounts);

  attemptCounts = resultsKeys.map(entry => {
    const { isCorrect, attemptCount } = results[entry];

    // we keep the attempt count for any question that isCorrect
    // in sync with the highestAttemptCount
    return isCorrect ? highestAttemptCount : attemptCount;
  });

  const lowestAttemptCount = Math.min(...attemptCounts);

  return lowestAttemptCount;
};

export { getAttempt };
